import React from "react";
const navIcon = (props) => {
  let navIcons = false;

  if (props.items.icon) {
    // navIcons = <span className="pcoded-micon"><i className={props.items.icon} /></span>;
    navIcons = (
      <span className="pcoded-micon">
        {/* <img
          src={`../../../../assets/images/icons/${props.items.icon}.svg`}
          alt={props.items.icon}
        ></img> */}
        <img
          src={props.items.icon}
          // src={require(`../../../../../../assets/images/icons/${props.items.icon}.svg`)}
          alt={props.imageName1}
        />
        {/* <i className={props.items.icon} /> */}
      </span>
    );
  }
  return navIcons;
};

export default navIcon;
